import Vue from 'vue'

export default {
  BO: {
    async doCheck (nit) {
      const _regexAdjust = /\D/gi
      nit = nit.replace(_regexAdjust, '')

      return await Vue.http.get('http://pbdw.impuestos.gob.bo:8080/gob.sin.padron.servicio.web/consulta/verificarContribuyente', {params: {nit}})
        .then(response => {
          if (response.body.ok && response.body.estado === 'ACTIVO') {
            return true
          } else {
            return false
          }
        })
    }
  },
  'CL': {
    doCheck: function (rut) {
      if (!rut || rut.trim().length < 3) return false
      const cleanedRut = rut.replace(/[^0-9kK-]/g, '')

      if (cleanedRut.length < 3) return false

      const split = cleanedRut.split('-')
      if (split.length !== 2) return false

      const num = parseInt(split[0], 10) // number
      const vd = split[1] // verifier digit

      const vdCalc = this.calculateVd(num)
      return vdCalc.toLowerCase() === vd.toLowerCase()
    },
    calculateVd: function (rut) {
      const body = `${rut}`
      let sum = 0
      let multiplier = 2

      for (let i = 1; i <= body.length; i++) {
        const index = multiplier * body.charAt(body.length - i)

        sum += index

        if (multiplier < 7) {
          multiplier += 1
        } else {
          multiplier = 2
        }
      }

      const vdExpected = 11 - (sum % 11)
      if (vdExpected === 10) return 'k'
      if (vdExpected === 11) return '0'
      return `${vdExpected}`
    }
  },
  CO: {
    doCheck(nit) {
      const _regexFormat = /^(\d|\.|-| )+$/
      const _regexAdjust = /\D/gi

      if (!nit) {
        return false
      }
      if (!_regexFormat.test(nit)) {
        return false
      }
      let adjustedNit = nit.replace(_regexAdjust, '')
      if (![9, 10].includes(adjustedNit.length)) {
        return false
      }

      return true
    }
  },
  CO_FULL: {
    doCheck(nit) {
      console.log(nit)
      return this.checkNit(nit)
    },
    checkNit(nit) {
      const _regexFormat = /^(\d|\.|-)+$/
      const _regexAdjust = /\D/gi
      const _baseMod = 11
      const _multipliers = [3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71]

      if (!nit) {
        return false
      }
      if (!_regexFormat.test(nit)) {
        return false
      }
      let adjustedNit = nit.replace(_regexAdjust, '')
      if (![9, 10].includes(adjustedNit.length)) {
        return false
      }

      let digit = adjustedNit.substr(adjustedNit.length - 1)
      let sequence = adjustedNit.substr(0, adjustedNit.length - 1).split('').reverse()
      let v = 0
      for (let index = 0; index < sequence.length; index++) {
        v += parseInt(sequence[index], 10) * _multipliers[index]
      }

      let check = v % _baseMod
      if (check >= 2) {
        check = _baseMod - check
      }
      console.log(check)
      console.log(parseInt(digit, 10))
      console.log(check === parseInt(digit, 10))
      return check === parseInt(digit, 10)
    }
  },
  MX: {
    doCheck: function (rfc) {
      rfc = rfc.toUpperCase().replace(/[^0-9A-ZÑ&]/g, '')

      return this.checkRfc(rfc)
    },
    checkRfc: function (rfc, acceptGeneric = true) {
      const re = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/
      let match = rfc.match(re)

      if (!match) return false

      // Separar el dígito verificador del resto del RFC
      let vd = match.pop()
      if (!isNaN(vd)) vd = parseInt(vd)

      const rfcWithoutDigit = match.slice(1).join('')
      const len = rfcWithoutDigit.length

      // Obtener el digito esperado
      const dict = '0123456789ABCDEFGHIJKLMN&OPQRSTUVWXYZ Ñ'
      const index = len + 1
      let sum
      let vdExpected

      if (len === 12) sum = 0
      else sum = 481 // Ajuste para persona moral

      for (let i = 0; i < len; i++) {
        sum += dict.indexOf(rfcWithoutDigit.charAt(i)) * (index - i)
      }

      vdExpected = 11 - sum % 11

      if (vdExpected === 11) vdExpected = 0
      else if (vdExpected === 10) vdExpected = 'A'

      // El dígito verificador coincide con el esperado?
      // o es un RFC Genérico (ventas a público general)?
      if ((vd !== vdExpected) &&
        (!acceptGeneric || rfcWithoutDigit + vd !== 'XAXX010101000')) return false
      else if (!acceptGeneric && rfcWithoutDigit + vd === 'XEXX010101000') return false
      return rfcWithoutDigit + vd
    }
  },
  PE: {
    doCheck(ruc) {
      ruc = Number(ruc.replace(/[^0-9]+/g, ''))
      return this.checkRuc(ruc)
    },
    checkRuc(ruc) {
      // 11 dígitos y empieza en 10, 15, 16, 17 o 20
      if (!(ruc >= 1e10 && ruc < 11e9 ||
        ruc >= 15e9 && ruc < 18e9 ||
        ruc >= 2e10 && ruc < 21e9)) {
        return false
      }
      const vdExpected = ruc % 10
      let sum = 0
      for (let i = 0; i < 11; i++, ruc = ruc / 10 | 0) {
        if (i !== 0) {
          sum += (ruc % 10) * (i % 7 + (i / 7 | 0) + 1)
        }
      }
      let reminder = 11 - (sum % 11)
      return reminder >= 10 ? (reminder - 10) === vdExpected : reminder === vdExpected
    }
  },
  QM: {
    doCheck: function (rut) {
      if (!rut || rut.trim().length < 3) return false
      const cleanedRut = rut.replace(/[^0-9kK-]/g, '')

      if (cleanedRut.length < 3) return false

      const split = cleanedRut.split('-')
      if (split.length !== 2) return false

      const num = parseInt(split[0], 10) // number
      const vd = split[1] // verifier digit

      const vdCalc = this.calculateVd(num)
      return vdCalc.toLowerCase() === vd.toLowerCase()
    },
    calculateVd: function (rut) {
      const body = `${rut}`
      let sum = 0
      let multiplier = 2

      for (let i = 1; i <= body.length; i++) {
        const index = multiplier * body.charAt(body.length - i)

        sum += index

        if (multiplier < 7) {
          multiplier += 1
        } else {
          multiplier = 2
        }
      }

      const vdExpected = 11 - (sum % 11)
      if (vdExpected === 10) return 'k'
      if (vdExpected === 11) return '0'
      return `${vdExpected}`
    }
  },
  QO: {
    doCheck: function (rfc) {
      rfc = rfc.toUpperCase().replace(/[^0-9A-ZÑ&]/g, '')

      return this.checkRfc(rfc)
    },
    checkRfc: function (rfc, acceptGeneric = true) {
      const re = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/
      let match = rfc.match(re)

      if (!match) return false

      // Separar el dígito verificador del resto del RFC
      let vd = match.pop()
      if (!isNaN(vd)) vd = parseInt(vd)

      const rfcWithoutDigit = match.slice(1).join('')
      const len = rfcWithoutDigit.length

      // Obtener el digito esperado
      const dict = '0123456789ABCDEFGHIJKLMN&OPQRSTUVWXYZ Ñ'
      const index = len + 1
      let sum
      let vdExpected

      if (len === 12) sum = 0
      else sum = 481 // Ajuste para persona moral

      for (let i = 0; i < len; i++) {
        sum += dict.indexOf(rfcWithoutDigit.charAt(i)) * (index - i)
      }

      vdExpected = 11 - sum % 11

      if (vdExpected === 11) vdExpected = 0
      else if (vdExpected === 10) vdExpected = 'A'

      // El dígito verificador coincide con el esperado?
      // o es un RFC Genérico (ventas a público general)?
      if ((vd !== vdExpected) &&
        (!acceptGeneric || rfcWithoutDigit + vd !== 'XAXX010101000')) return false
      else if (!acceptGeneric && rfcWithoutDigit + vd === 'XEXX010101000') return false
      return rfcWithoutDigit + vd
    }
  }
}
